module.exports = __webpack_public_path__ + "static/media/wayPointImg.5a123608.svg";